import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { GlobalContext } from '../GlobalContext'
import { FaBed } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';
import { motion, AnimatePresence } from "framer-motion";
import { FaHome } from "react-icons/fa";
import { FaHeart } from 'react-icons/fa';
import { toggleSaveProperty, checkPropertySaved } from '../services/Api';




export default function Properties({
    
    countMessage,
    paddingClasses = 'pt-[20px] lg:pt-[20px]',
    sortBy = 'latest',
    getPropertyData,
    selectedCategory,
    setSelectedCategory,
    isLoading,
    onPageChange, // Default to a no-op function
    nextPage,
    handleLoadMore
}) {
    const { t } = useTranslation();
    const [savedProperties, setSavedProperties] = useState({});
    const [savingId, setSavingId] = useState(null);

    const { selectedLocation, setSelectedLocation, getProperty, setLocationSelect, propertyCategory, setPropertyCategory, setActiveFilter, setGetProperty, page, setPage, globalVar } = useContext(GlobalContext);
    const [selectedCategoryPro, setSelectedCategoryPro] = useState('');

    const locations = ['Abu Dhabi', 'Dubai', 'Sharjah', 'Ajman', 'Umm Al Quwain', 'Ras Al Khaimah', 'Fujairah'];

// const handleLoadMore = () => {
//     // Check if we're not loading already and there is a next page
//     if (!isLoading && nextPage) {
//         setPage(nextPage); // Increment the page number
//         // Fetch the next set of properties
//         onPageChange(nextPage); // Trigger data fetch for the next page
//     }
// };


    const handleCategoryClick = (category) => {
        if (category === selectedCategory) return; // prevent redundant clicks
        setPropertyCategory(category);
        setSelectedCategory(category);
        setGetProperty([]);
    };

    const handleLocationClick = (location) => {
        if (location === selectedLocation) return; // prevent re-click
        setSelectedLocation(location);
        setGetProperty([]); // optional: reset list
    };

    const handleToggleSave = async (propertyId) => {
        setSavingId(propertyId);
        try {
            const res = await toggleSaveProperty(propertyId);
            setSavedProperties((prev) => ({
            ...prev,
            [propertyId]: res.is_saved
            }));
        } catch (err) {
            console.error(`Error toggling save for property ${propertyId}`, err);
        } finally {
            setSavingId(null);
        }
    };
    useEffect(() => {
    const fetchSavedStatus = async () => {
        if (!getPropertyData?.length) return;

        const statusMap = {};
        for (const property of getPropertyData) {
        try {
            const res = await checkPropertySaved(property.id);
            statusMap[property.id] = res.is_saved;
        } catch (err) {
            console.error(`Error checking saved status for property ${property.id}`, err);
        }
        }
        setSavedProperties(statusMap);
    };

    fetchSavedStatus();
    }, [getPropertyData]);






    return (
        <section id="properties-section" className={`${paddingClasses} pb-8 px-6 sm:px-8 lg:px-12 bg-gray-50`}>
            <div>
 <div className="text-center py-6 overflow-hidden">
                    <AnimatePresence mode="wait">
                        {/* Show loading message while properties are being fetched */}
                        {isLoading && !countMessage && (
                            <motion.div
                                key="loading"
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                exit={{ opacity: 0 }}
                                transition={{ duration: 0.6, ease: [0.4, 0, 0.2, 1] }}
                                className="inline-block bg-gradient-to-r from-teal-500 via-cyan-500 to-teal-500 bg-opacity-20 text-white text-xl sm:text-2xl md:text-3xl font-semibold px-6 py-3 rounded-full shadow-none backdrop-blur-sm"
                            >
                                <span className="inline-flex items-center gap-2">
                                    <FaHome className="text-white text-xl sm:text-2xl hidden md:inline-block" />
                                    {t('loading')}
                                </span>
                            </motion.div>
                        )}

                        {/* Show the correct count message after fetching properties */}
                        {countMessage && !isLoading && (
                            <motion.div
                                key={countMessage}
                                initial={{ clipPath: 'inset(0 100% 0 0)', opacity: 0 }}
                                animate={{ clipPath: 'inset(0 0% 0 0)', opacity: 1 }}
                                exit={{ opacity: 0 }}
                                transition={{ duration: 0.6, ease: [0.4, 0, 0.2, 1] }}
                                className="inline-block bg-gradient-to-r from-teal-500 via-cyan-500 to-teal-500 bg-opacity-20 text-white text-xl sm:text-2xl md:text-3xl font-semibold px-6 py-3 rounded-full shadow-none backdrop-blur-sm"
                            >
                                <span className="inline-flex items-center gap-2">
                                    <FaHome className="text-white text-xl sm:text-2xl hidden md:inline-block" />
                                    {countMessage}
                                </span>
                            </motion.div>
                        )}
                    </AnimatePresence>
                </div>
            




         <div className='flex flex-wrap justify-center items-center mb-6 gap-2'>
                   {/* <h2 className="text-3xl text-center mb-10 sm:text-2xl md:text-3xl font-bold text-gray-800">
  {t('properties_section_heading')}
</h2> */}

                </div>
            </div>

            {/* Property Listings */}
           <div className="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                {getProperty.length > 0 ? (
  getProperty.map((property) => (
    // your property cards


                        <Link
                            key={property.id}
                            to={`/property-detail/${property.id}`}
                            className="block bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition"
                        >
                                <div className="relative">
                                    <img
                                        src={property.images?.[0]?.image
                                            ? property.images[0].image.startsWith('/media')
                                                ? `${globalVar}${property.images[0].image}`
                                                : property.images[0].image
                                            : '/placeholder.jpg'}
                                        alt="Property"
                                        className="h-50 w-100 object-cover"
                                    />
                                    

                                    {/* Category */}
                                    <span className="absolute top-2 left-2 bg-black bg-opacity-60 text-white text-xs font-medium px-2 py-1 rounded">
                                       {/* {t(`categories.${property.category?.name?.toLowerCase()}`, property.category?.name)} */}
{t(
      `static.${property.category.name.toLowerCase().replace(/[-\s]/g, "_")}`,
      property.category.name
    )}

                                    </span>

                                    {/* Delivery Date */}
                                    {property.delivery_date && (
                                        <span className="absolute top-2 right-2 bg-white text-black text-xs font-semibold px-2 py-1 rounded shadow-md">
                                            {new Date(property.delivery_date).toISOString().split('T')[0]}
                                        </span>
                                    )}

                                    
                                </div>

                                <div className="p-4 space-y-1 relative">
                                    <button
                                        onClick={() => handleToggleSave(property.id)}
                                        disabled={savingId === property.id}
                                        className={`absolute top-2 right-2 z-10 text-xl ${
                                            savedProperties[property.id] ? 'text-teal-500' : 'text-gray-400 hover:text-teal-300'
                                        }`}
                                        title={savedProperties[property.id] ? 'Unsave' : 'Save'}
                                        >
                                        <FaHeart />
                                    </button>

                                    
                                    {/* Price + Unit Type */}
                                    <div className="flex justify-between items-center text-sm text-gray-800 font-semibold">
                                        {property.price > 0 && (
<span className="text-black">
  {i18n.language === 'ar'
    ? `${Math.round(property.price).toLocaleString()} ${t("currency.dirham")}`
    : `${t("currency.dirham")} ${Math.round(property.price).toLocaleString()}`}
</span>


                                    )}
                                      <span className="text-gray-600 text-xs">
  {
    property.units?.length > 0
      ? [...new Set(property.units.map(unit => unit.unit_type))]
          .filter(Boolean)
          .map(type => t(`unit_types.${type?.toLowerCase().replace(/\s/g, '_')}`, type))
          .join(', ')
      : t(`unit_types.${property.property_type?.name?.toLowerCase().replace(/\s/g, '_')}`, property.property_type?.name)
  }
</span>

                                    </div>

                                    {/* Title */}
                                    <h3 className="text-md font-semibold text-gray-800 line-clamp-1">
                                        {property.title}
                                    </h3>

                                    {/* Location + Community */}
                                   <p className="text-sm text-gray-500">
  {t(`emirates.${property.location?.emirate?.toLowerCase().replaceAll(" ", "_")}`, property.location?.emirate)}
  {property.community?.slug ? (
    ` / ${t(`communities.${property.community.slug}`, property.community.name)}`
  ) : ""}
</p>

                                    <div className="flex justify-between items-center text-sm text-gray-600 mt-2">
                                        {/* Bedrooms */}
                                        {[...new Set(property.units?.map(unit => unit.rooms))]
                                            .filter(room => room)
                                            .length > 0 && (
                                            <span className="flex items-center gap-1">
                                                <FaBed className="text-gray-500" />
                                                {
                                                    [...new Set(property.units?.map(unit => unit.rooms))]
                                                    .filter(room => room)
                                                    .sort((a, b) => Number(a) - Number(b))
                                                    .join(', ')
                                                }
                                            </span>
                                        )}

                                        {/* Area */}
                                        <span>
  {i18n.language === 'ar'
    ? `${property.area_sqft.toLocaleString()} ${t("static.sqft")}`
    : `${property.area_sqft.toLocaleString()} ${t("static.sqft")}`}
</span>

                                    </div>
                                </div>
                            </Link>
                        ))

) : null}
            </div>

            {/* Load More button */}
            {getProperty.length > 0 && nextPage !== null && (
                <div className="mt-10 text-center">
                    <button
                        onClick={handleLoadMore}
                        disabled={isLoading}
                        className="px-8 py-3 bg-teal-500 hover:bg-teal-600 text-white font-medium rounded-full transition"
                    >
                        {isLoading ? t('loading') : t('load_more')}
                    </button>
                </div>
            )}
        </section>
    );
}
